<div class="setting-rap" [ngClass]="{ 'setting-rap-header': header, 'setting-rap-dark': isDarkModeCheck && header }" >
    <div class="model-setting " [ngClass]="{ top: isResearchType}" *ngIf="openSetting">
      <div *ngIf="isResearchType" class="top model-sc btn-model ">
        <div class="text-btn">Number of Sources to return </div>
        <input type="number" [(ngModel)]="numberOfResearch" (change)="saveToLocalStorage()" max="50">
      </div>
      <div class="model-sc">
        <button class="btn-rm btn-model">
          <div class="img-text">
            <img [src]="isDarkModeCheck? '../../../assets/icons/moon-w.svg' : '../../../assets/icons/moon.svg'"
              width="24" height="24" />
            <div class="text-btn">Use dark theme</div>
          </div>
          <label class="switch">
            <input type="checkbox" id="darkModeSwitch" (change)="toggleDarkMode()" [(ngModel)]="darkModeToggle" />
            <span class="slider round"></span>
          </label>
        </button>
      </div>
      <div class="model-sc">
        <button class="btn-rm btn-model" (click)="logout()">
          <div class="img-text">
            <img *ngIf="isDarkModeCheck === false" src="../../../assets/icons/logout.svg" width="24" height="24" />
            <img *ngIf="isDarkModeCheck" src="../../../assets/icons/logout-w.svg" width="24" height="24" />
            <div class="text-btn">Log out</div>
          </div>
        </button>
      </div>
    </div>
    <button id="setting-info" class="btn-rm btn-ssetting" (click)="setOpenSetting()" mat-button>
      <!-- #toggleButtonSetting -->
      <div class="toggleButtonSetting setting" [style.background-color]="
          openSetting
            ? !isDarkModeCheck
              ? '#EFEFEF'
              : 'rgba(255, 255, 255, 0.20)'
            : ''
        ">
        <div class="name">
          <div class="name-c">{{ this.firstLetterName }}</div>
          <div>{{ this.userName }}</div>
        </div>
        <!-- <img [src]="
            !isDarkModeCheck
              ? '../../../assets/icons/dot-horizontal.svg'
              : '../../../assets/icons/dot-horizontal-w.svg'
          " width="24" height="24" /> -->
      </div>
    </button>
  </div>
